import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import start from './start';
import '@/assets/element_style/theme/index.css'
import 'bootstrap/dist/css/bootstrap.css'
import '@/less/style_admin.less'
import Auth from './util/auth'
import Http from './util/http'
import Crypto from './util/crypto'
import Websocket from './util/websocket'
import Sqlite from './util/sqlite'
import Public from './util/public'
import infiniteScroll from 'vue-infinite-scroll'//往下載入更多
import Date from './util/date'
import Payment from './util/payment'

//圖片放大
import VuePreview from 'vue-preview';
let previewOptions = {
    mainClass: 'pswp--minimal--dark',
    barsSize: {top: 0, bottom: 0},
    captionEl: false,
    fullscreenEl: false,
    shareEl: false,
    bgOpacity: 0.85,
    tapToClose: true,
    tapToToggleControls: false
}
Vue.use(VuePreview, previewOptions);

//eventBus
export const EventBus = new Vue();

//每頁的頭部
import NavigationBar from './components/NavigationBar';
Vue.component('navigation-bar',NavigationBar)

//載入動畫
import 'vue-loading-overlay/dist/vue-loading.css'
import VueLoading from "vue-loading-overlay";
Vue.component('Loading',VueLoading);

/*DatePickter*/
import DatePicker from 'vue2-datepicker';
Vue.use(DatePicker);

import InfiniteLoading from 'vue-infinite-loading';
Vue.use(InfiniteLoading, { /* options */ });

//載入手勢
import gesture from 'better-gesture';
Vue.use(gesture);

//Liff init 註冊全域liff
import liff from "@line/liff"
Vue.prototype.$liff = liff;
liff.init({
    liffId: "2008934720-dx73LUSg",
    // withLoginOnExternalBrowser: true
}).then(() => {
    console.log("liff init success.");
}).catch((err) => {
    console.error("liff init error: ", err);
});
Vue.prototype.$liff = liff;

//網頁用的 QRScanner
// import QRScanner from 'cordova-plugin-qrscanner';
// Vue.use(QRScanner, {});

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(infiniteScroll);

Vue.prototype.$auth = Auth;
Vue.prototype.$http = Http;
Vue.prototype.$crypto = Crypto;
Vue.prototype.$socket = Websocket;
Vue.prototype.$sqlite = Sqlite;
Vue.prototype.$public = Public;
Vue.prototype.$preview = VuePreview;
Vue.prototype.$date = Date;
Vue.prototype.$payment = Payment;
Vue.prototype.$eventBus = EventBus;

start.mountVue(store, router, App, Sqlite);

